//React
import React from "react";
import PropTypes from "prop-types";
//CSS
import "./inputs.scss";

/**
 * Label + helper text around a control (ASB-3988). The criteria cards drew this
 * by hand in 12 files as `.chips-label` / `.chips-info` (or `.input-info`), each
 * card's SCSS restyling it. This is that pattern once: label above, helper text
 * beneath the label, the control, then an error line. `required` adds the
 * shared red asterisk via `.input-wrapper.required > label::after`, the same
 * mark every other input carries.
 *
 *   <FieldGroup label="Target Users From Other Cohorts" info="Cohorts cannot target …" htmlFor="sub-cohorts">
 *     <Select … />
 *   </FieldGroup>
 */
function FieldGroup({ label, info, error, required, htmlFor, children, className }) {
	const classes = [
		"input-wrapper as-field-group",
		required ? "required" : "not-required",
		error ? "error" : "valid",
		className ?? "",
	];
	return (
		<div className={classes.join(" ").trim()}>
			{label ? (
				<label
					className="as-field-group__label"
					htmlFor={htmlFor}
				>
					{label}
				</label>
			) : null}
			{info ? <div className="as-field-group__info">{info}</div> : null}
			{children}
			{typeof error === "string" && error ? (
				<div
					className="input-error"
					role="alert"
				>
					{error}
				</div>
			) : null}
		</div>
	);
}

FieldGroup.propTypes = {
	label: PropTypes.node,
	/** helper text shown under the label */
	info: PropTypes.node,
	/** true = error styling; string = error styling + that message */
	error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	required: PropTypes.bool,
	/** id of the control the label is for */
	htmlFor: PropTypes.string,
	children: PropTypes.node,
	className: PropTypes.string,
};

export default FieldGroup;
